// extracted by mini-css-extract-plugin
module.exports = {"StoreItem":"StoreItem_StoreItem__3oG9O","ImageContainer":"StoreItem_ImageContainer__3Yd80"};